import { Outlet } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import TopBar from "@/components/site/TopBar";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--eel-bg)] text-[var(--eel-text)]">
      <TopBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
